import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../contexts/AuthProvider";

import { API_URL } from "../utils/config";
const baseUrl = API_URL;
export const useProduct = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [product, setProduct] = useState(null);
    const [oldImagesFiles, setOldImagesFiles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { isAuthenticated } = useAuth();

  

    const getLangFromLocalStorage = () => {
        return localStorage.getItem("language") || "en";
    };

    const fetchProduct = async () => {
        try {
            if (!isAuthenticated) return;
            const response = await fetch(`${baseUrl}/api/v1/attnd-supplier/services/${id}`, {
                method: "GET",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    lang: getLangFromLocalStorage(),
                },
            });

            if (response.status === 404) {
                navigate("/dashboard");
                throw new Error("Order not found");
            }

            if (!response.ok) {
                if (response.status === 401) throw new Error("Unauthorized");
                throw new Error("Failed to fetch product");
            }

            const { data } = await response.json();
            if (data) {
                const productData = {
                    id: data.id,
                    sku: data.sku,                  // Added SKU handling
                    name: data.name,
                    name_ar: data.name_ar,
                    description_ar: data.description_ar, // Added Arabic description
                    type: data.type,
                    offer_type: data.offer_type,       // Added offer_type handling
                    description: data.description,
                    price: data.price,
                    shipping_price: data.shipping_price,
                    shipping_period: data.shipping_period,
                    minimum_order: data.minimum_order,
                    quantity: data.quantity,
                    supplier_id: data.supplier_id,
                    status: data.status,
                    active: data.active,
                    customized: data.customized, // Added customized field
                };

                setProduct(productData);
                setOldImagesFiles(data.images);
            }
        } catch (err) {
            console.error("Error fetching product:", err);
            if (err.message === "Unauthorized") navigate("/login");
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProduct();
    }, [id]);

    return { product, oldImagesFiles, loading, error }; 
};
